<div class="modal-header">
  <div class="header-content">
    <h5 class="modal-title">Detalles de la cuenta</h5>
    <div class="d-flex justify-content-start align-items-center">
      <span class="badge badge-success mr-2">{{cuenta?.codigo}}</span>
      <span class="text-success">{{cuenta?.alias}}</span>
    </div>
  </div>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cancelar')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ul class="list-group">
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Moneda</span>
      <span class="list-value">{{cuenta?.moneda}}</span>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Disponible</span>
      <span class="list-value">{{cuenta?.saldoDisponible | currency}}</span>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Cheques</span>
      <span class="list-value">{{cuenta?.saldoRetencion | currency}}</span>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Bloqueos</span>
      <span class="list-value">{{cuenta?.saldoBloqueos | currency}}</span>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Saldo Total</span>
      <span class="list-value">{{cuenta?.saldo | currency}}</span>
    </li>
  </ul>
</div>
